import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from '../text-field';
import debounce from 'utils/debounce';
import { withEditSpot } from '../../../../../spots/hoc/withEditSpot';

class SpotNameInput extends Component {
  constructor(props, context) {
    super(props, context);
    var spotName = props.value ? props.value : null;
    this.state = {
      status: 'none',
      message: '',
      spotName,
      isDirty: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.state.isDirty) {
      if (nextProps.validate) {
        this.onSpotNameChange(this.state.spotName || nextProps.value, true);
      } else if (nextProps.value !== this.state.spotName) {
        this.setState({ spotName: nextProps.value });
      }
    }
  }

  UNSAFE_componentWillMount() {
    this.saveSpotName = debounce(this.saveSpotName.bind(this), 0);
  }

  saveSpotName() {
    if (this.props.autoSave) {
      this.props.editSpot(this.props.spotId, { name: this.state.spotName });
    }
  }

  onSpotNameChange(_spotName, onlyUpdate) {
    var empty = !_spotName || !_spotName.trim().length;
    var { success, message, status, spotName } = this.state;

    onlyUpdate = !!onlyUpdate;

    success = null;
    if (empty) {
      message = "You can't leave this empty.";
      status = 'error';
    } else {
      status = 'success';
      message = '';

      if (!onlyUpdate) {
        this.saveSpotName();
      }
    }
    spotName = _spotName;
    this.setState({ success, message, status, spotName, isDirty: true });
  }

  getValue() {
    return this.state.spotName;
  }

  isValid() {
    return this.state.status === 'success';
  }

  render() {
    var spotName = this.state.spotName;
    var validation = {
      status: this.state.status || 'none',
      message: this.state.message
    };

    return (
      <TextField
        type="text"
        className="outside"
        onChange={this.onSpotNameChange.bind(this)}
        title="Site Name"
        description="Choose the public name for your site. This will also serve as title for your Newsfeed. We recommend you simply use your website's name."
        validation={validation}
        showValidationTooltip
        maxLength={20}
        value={spotName}
      />
    );
  }
}

SpotNameInput.propTypes = {
  autoSave: PropTypes.bool,
  showValidationTooltip: PropTypes.bool,
  spotId: PropTypes.string,
  validate: PropTypes.bool,
  value: PropTypes.string
};

SpotNameInput.defaultProps = {
  autoSave: false,
  showValidationTooltip: false,
  spotId: null,
  value: null
};

SpotNameInput.displayName = 'SpotNameInput';

export default withEditSpot(SpotNameInput);
